import { render } from "./a-carousel.vue?vue&type=template&id=726138a8&scoped=true"
import script from "./a-carousel.vue?vue&type=script&lang=js"
export * from "./a-carousel.vue?vue&type=script&lang=js"

import "./a-carousel.vue?vue&type=style&index=0&id=726138a8&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726138a8"]])

export default __exports__